import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-w-full table-paper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Account"),
    /*#__PURE__*/_createElementVNode("th", null, "Fields"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "font-mono" }
const _hoisted_6 = { class: "whitespace-nowrap" }
const _hoisted_7 = { class: "w-px" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", { class: "table-no-hover" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "text-gray-400",
    colspan: "420"
  }, " This program has no accounts ")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Fields"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "font-mono" }
const _hoisted_15 = { class: "whitespace-nowrap" }
const _hoisted_16 = { class: "w-px" }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("tr", { class: "table-no-hover" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "text-gray-400",
    colspan: "420"
  }, " This program has no types ")
], -1)
const _hoisted_19 = [
  _hoisted_18
]

import { toRefs } from 'vue';
import { AccountPresenter, AnchorProgram } from '@/models';
import { useModal } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: AnchorProgram,
  presenter: AccountPresenter,
}



const { open: openModal } = useModal();
const { account } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_base_table_separator = _resolveComponent("base-table-separator")!
  const _component_base_list_summary = _resolveComponent("base-list-summary")!
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!
  const _component_base_table_overflow_container = _resolveComponent("base-table-overflow-container")!

  return (_openBlock(), _createBlock(_component_base_table_overflow_container, null, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_base_table_separator),
        (_unref(account).anchorIdl?.accounts?.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account).anchorIdl.accounts, (idlAccount) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: idlAccount.name,
                  onClick: ($event: any) => (_unref(openModal)('sidepage-anchor-account', { anchorProgram: _unref(account), idlAccount }))
                }, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(idlAccount.name), 1),
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(_component_base_list_summary, {
                      array: idlAccount?.type?.fields ?? [],
                      fn: field => field.name
                    }, null, 8, ["array", "fn"])
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_icon_arrow_right, { class: "table-hover-icon" })
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_8, _hoisted_10)),
        _createVNode(_component_base_table_separator),
        _hoisted_11,
        _createVNode(_component_base_table_separator),
        (_unref(account).anchorIdl?.types?.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account).anchorIdl.types, (idlType) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: idlType.name,
                  onClick: ($event: any) => (_unref(openModal)('sidepage-anchor-type-explorer', { type: idlType, idl: _unref(account).anchorIdl, kind: 'type' }))
                }, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(idlType.name), 1),
                  _createElementVNode("td", _hoisted_15, [
                    _createVNode(_component_base_list_summary, {
                      array: idlType?.type?.fields ?? [],
                      fn: field => field.name
                    }, null, 8, ["array", "fn"])
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    _createVNode(_component_icon_arrow_right, { class: "table-hover-icon" })
                  ])
                ], 8, _hoisted_13))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_17, _hoisted_19))
      ])
    ]),
    _: 1
  }))
}
}

})